type DefensorComNascimento = {
  data_nascimento?: string | Date;
  pessoa?: { dataNascimento?: string | Date };
} | null | undefined;

/** Retorna a data de nascimento do defensor, independente do formato da API. */
export function getDataNascimentoDefensor(
  defensor: DefensorComNascimento,
): string | Date | undefined {
  return defensor?.data_nascimento ?? defensor?.pessoa?.dataNascimento;
}
